<template>


<div class="container">
	<div class="row">
		<div class="col-lg-8">
		<h1>Processes, Projects, Products Assessments</h1>
		<small class="text-muted">
			Getting independed assessment of your processess and prducts enables you to prioritise your projects more efficiently
		</small>
<p class="lead">
Whenever you need to get an accurate picture of your company, your partners, suppliers processes, capabilities, readiness to expand or pinpoint the areas that require improvement, we can help you by evaluating every process in terms of:
<ul>
<li>efficiency</li>
<li>quality</li>
<li>compliance</li>
<li>risk</li>
</ul>
</p>



<p>
Depending on the requirements, the analysis scope can cover only a single project related process, or it can be company-wide process evaluation covering areas such as:
<ul>
<li>team integrity</li>
<li>planning processes</li>
<li>development processes</li>
<li>quality control</li>
<li>deployment processes</li>
<li>infrastructure</li>
<li>data management</li>
<li>support &  maintenance</li>
</ul>
</p>

		</div>
		<div class="col-lg-4">


			<div class="card my-5">
				<div class="card-body bg-success text-secondary">
					<h5 class="card-title text-secondary">Infrastructure, Deployments, Monitoring</h5>
					<p class="card-text">
Whenever you need 24/7 monitoring and support services, or just regular application deployment and system updates, we can help you
					</p>
					<a href="#/maintenance_and_support" class="btn btn-outline-white">More info</a>
				</div>
			</div>

			<div class="card my-5">
				<div class="card-body bg-primary text-secondary">
					<h5 class="card-title text-secondary">AI, Blockchain, Smart tech</h5>
					<p class="card-text">Smart technologies are not a new trend any more. It makes applications more efficient and user-oriented, creates publicity for the company, attracts investors and partners.</p>
					<a href="#/innovations" class="btn btn-outline-white">More info</a>
				</div>
			</div>

		</div>
	</div>
</div>


</template>

<script>
export default {
	data() {
		return {
			metadata: {
				section: "service",
				title: "Processes, Projects, Products Assessments"
			}
		}
	},
	methods: {
		loadToParent: function() {
			this.$emit("data-to-parent", this.metadata);
		}
	},
	mounted: function() {
		this.loadToParent();	
	},
}
</script>
